import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router-dom';

import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { AllSiteUsersSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { RouterError } from '../../../../bootstrap/routerHelpers/RouterError';
import { AllSiteUsersAndIdentitiesSpaceProvider } from './AllSiteUsersAndIdentitiesSpaceProvider';

export interface AllSiteUsersAndIdentitiesForSingleSiteSpaceRouterProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly urls: SpacesSiteUrls;
  readonly siteName: string;
}

export class AllSiteUsersAndIdentitiesForSingleSiteSpaceRouter extends React.Component<AllSiteUsersAndIdentitiesForSingleSiteSpaceRouterProps> {

  constructor(props: AllSiteUsersAndIdentitiesForSingleSiteSpaceRouterProps) {
    super(props);
  }

  public render() {
    return (
      <Switch>
        {/* The old users root path will still render the list page for easier backwards compatibility with test frameworks or other UI automation
             that may rely on using that path. */}
        <Route exact path={this.props.urls.usersPath()} render={this.provider('list')} />
        <Route exact path={this.props.urls.allUserIdentitiesPath()} render={this.provider('identities')} />

        <Route render={() => <RouterError errorType={'default'} urls={this.props.urls} />} />
      </Switch>
    );
  }

  private provider = (subspaceName: AllSiteUsersSubspaceName): (props: RouteComponentProps) => JSX.Element => {
    return (): JSX.Element => {
      return <AllSiteUsersAndIdentitiesSpaceProvider {...this.props}
        subspaceName={subspaceName}
      />;
    };
  };
}
